import { render } from "./UIUXContact.vue?vue&type=template&id=118a3466"
import script from "./UIUXContact.vue?vue&type=script&lang=js"
export * from "./UIUXContact.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__